export enum ApplicationEventNames {
    DepositSuccess = 'deposit_success',
    MakeManagedPortfolio = 'make_managed',
    TradeInitiated = 'trade_initiated',
    OrderCanceled = 'order_canceled',
    DepositModalClosed = 'deposit_modal_closed'
}
